/* eslint-disable react-hooks/exhaustive-deps */
import classNames from 'classnames';
import { useEffect, useMemo, useRef, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { MdArrowBackIos } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { CREATE_ROOM_MUTATION, CREATE_UPDATE_TEAM, EDIT_PARTICIPANTS_UPDATE, FORWARD_FILE_MSG_MUTATION, FORWARD_MSG_MUTATION } from '../../apollo/Mutations';
import toast from 'react-hot-toast';
import { setPopup, updateConversationMap } from '../../redux/messageSlice';
import { useNavigate } from 'react-router-dom';
import { slugify } from '../../Utils/Common';
import FileForwardComment from '../connect/chat/FileForwardComment';


// const colorPlate = ['#2C56AC', '#ff9988', '#7ed6d0', '#8b57db', '#2c56ac', '#a6d068', '#69abf9', '#ffaf4c'];

const ListOfUsers = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user, allUsers, userList, conversations, active_conversation, active_msg, active_file, online_users } = useSelector(state => state.message)
    const stepKey = userList.state ? userList.key : props.stepkey;
    const [loader, setLoader] = useState(false);
    const [actionLoader, setActionLoader] = useState(false);
    const [forward_file, setForward_file] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selected_ids, setSelected_ids] = useState([]);
    const searchInput = useRef(null);

    useEffect(() => {
        setLoader(false);
    }, []);

    const selectUser = (v) => {
        console.log("🚀 ~ selectUser ~ v:", v)
        if (stepKey === 'directConv') {
            setSelected_ids([v.id])
        } else {
            setSelected_ids(prev => {
                return prev.includes(v.id) ? prev.filter(f => f !== v.id) : [...prev, v.id]
            })
        }
    };

    const handleClosePopup = () => {
        setSelected_ids([])
        if (stepKey === 'createRoom' || stepKey === 'update_room') {
            props.setUserPopup(false)
        } else if (stepKey === 'private_msg') {
            dispatch(setPopup({ key: 'upload_popup', value: false }))
            dispatch(setPopup({ key: 'private_msg', value: false }))
        } else {
            dispatch(setPopup({ key: 'userList', value: { state: false, key: '' } }))
        }
    };

    useEffect(() => {
        // let isMounted = true
        function initial() {
            switch (stepKey) {
                case 'private_msg':
                    setSelected_ids(props.form_data)
                    break;
                case 'private_participants':
                    setSelected_ids(active_msg?.secret_user);
                    break;
                case 'createRoom':
                    setSelected_ids(props.form_data.participants)
                    break;
                case 'update_room':
                    setSelected_ids(props.form_data.participants)
                    break;
                case 'add_team_users':
                    setSelected_ids(props.team_users || [])
                    break
                default:
                    break;
            }

        }
        initial();
    }, [])

    useEffect(() => {
        console.log(101, selected_ids);

    }, [selected_ids])


    const returnAllusers = () => {
        console.log("🚀 ~ returnAllusers ~ stepKey:", stepKey)
        switch (stepKey) {
            case 'directConv':
                return allUsers.filter(f => f.id !== user?.id).map(v => ({ ...v, title: v.firstname + ' ' + v.lastname }));
            case 'forward':
            case 'forward_file': {
                const usrs = allUsers?.filter(f => f.id !== user?.id).map(v => ({ ...v, title: v.firstname + ' ' + v.lastname }));
                const convs = conversations?.filter(f => f.conversation_id !== user?.id).map(v => ({ ...v, title: v.title, id: v.conversation_id, img: v.conv_img, fnln: v.title.slice(0, 1) })).filter(u => u.conversation_id !== active_conversation?.conversation_id);
                return [...usrs, ...convs]
            }
            case 'createRoom':
                return allUsers.filter(f => f.id !== user?.id && f.role !== 'Guest' && props.teamParticipants?.includes(f.id)).map(v => ({ ...v, title: v.firstname + ' ' + v.lastname }));
            case 'update_room':
                return allUsers.filter(f => f.id !== user?.id && !props.form_data?.participants_admin?.includes(f.id) && f.role !== 'Guest' && props.teamParticipants?.includes(f.id)).map(v => ({ ...v, title: v.firstname + ' ' + v.lastname }));
            case 'private_msg':
                return allUsers.filter(f => f.id !== user?.id).filter(u => active_conversation?.participants?.includes(u.id)).map(v => ({ ...v, title: v.firstname + ' ' + v.lastname }));
            case 'private_participants':
                return allUsers.filter(f => f.id !== user?.id).filter(u => active_conversation?.participants.includes(u.id)).map(v => ({ ...v, title: v.firstname + ' ' + v.lastname }));
            case 'add_team_users':
                return allUsers.filter(f => f.id !== user.id).map(v => ({ ...v, title: v.firstname + ' ' + v.lastname }));
            default:
                return [];
        }
    }
    const all_users = useMemo(() => returnAllusers(), [stepKey, user]);
    console.log("🚀 ~ ListOfUsers ~ all_users:", all_users)

    const filterUser = (_type) => {
        const rooms = all_users.filter(f => f.conversation_id)
        const user = all_users.filter(f => !f.conversation_id)

        if (_type === 'room') {
            return rooms;
        } else {
            let single = rooms?.filter(f => f.group === 'no')?.map(m => m.friend_id)
            let singleUni = user.filter(f => !single.includes(f.id))
            return singleUni;
        }
    }

    const [updateTeam] = useMutation(CREATE_UPDATE_TEAM);

    const addTeamMembers = async () => {
        try {
            setActionLoader(true)
            // Update the team with the unique participants
            const { data } = await updateTeam({
                variables: {
                    input: {
                        title: props.activeTeam?.team_title,
                        type: 'update_conv_also',
                        participants: [...selected_ids],
                        team_id: props.activeTeam?.team_id
                    }
                }
            });
            console.log(164, data.create_update_team);
            if (data.create_update_team.status) {
                props.onConfirm(selected_ids)
                toast.success(data.create_update_team.message);
            } else {
                toast.error(data.create_update_team.message);
            }
            setActionLoader(false)
            handleClosePopup()
        } catch (error) {
            setActionLoader(false)
            console.log(error);
        }
    }

    const handleSubmit = () => {
        switch (stepKey) {
            case 'directConv':
                createDirectConversation()
                break
            case 'createRoom':
                props.setForm_data(prev => ({ ...prev, participants: [user.id, ...selected_ids.filter(f => f !== user.id)] }))
                props.setUserPopup(false)
                break
            case 'update_room':
                props.setForm_data(prev => ({ ...prev, participants: [user.id, ...selected_ids.filter(f => f !== user.id)] }))
                props.setUserPopup(false)
                break
            case 'forward':
                handleForward()
                break
            case 'forward_file':
                setForward_file(true)
                break
            case 'private_participants':
                updatePrivateParticipants()
                break
            case 'private_msg': {
                props.setForm_data([user.id, ...selected_ids.filter(f => f !== user.id)])
                props.setUserPopup('upload')
                break
            }
            case 'add_team_users': {
                addTeamMembers()
                break
            }
            default: break;
        }
    }

    const [createDirect] = useMutation(CREATE_ROOM_MUTATION);
    const createDirectConversation = async () => {
        setLoader(true)
        try {
            let { data } = await createDirect(
                {
                    variables: {
                        input: {
                            title: 'Personal',
                            participants: [user?.id, ...selected_ids],
                            company_id: user?.company_id,
                            group: 'no'
                        }
                    }
                }
            );

            let slug = slugify(data.create_room.data.title)
            toast.success(data.create_room.message)
            dispatch(updateConversationMap({ key: slug, value: data.create_room.data.conversation_id }));
            navigate('/connect/' + slug)
            handleClosePopup()
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.log(error)
        }
    }

    const [updatePrivateParticipantsMethod] = useMutation(EDIT_PARTICIPANTS_UPDATE);
    const updatePrivateParticipants = () => {
        let old = active_msg?.secret_user
        let a_ids = selected_ids?.filter((i) => old.indexOf(i) === -1);
        let r_ids = old.filter((i) => selected_ids?.indexOf(i) === -1);
        updatePrivateParticipantsMethod({
            variables: {
                input: {
                    conversation_id: active_msg?.conversation_id,
                    msg_id: active_msg?.msg_id,
                    add_secret_user: a_ids,
                    remove_secret_user: r_ids
                }
            }
        });

        dispatch(setPopup({ key: 'userList', value: { key: '', state: false } }))
    }

    const [forward] = useMutation(FORWARD_MSG_MUTATION)
    const [forwardFile] = useMutation(FORWARD_FILE_MSG_MUTATION)

    const handleForward = async (msg_body = '') => {
        const selectedUsers = all_users.filter(u => selected_ids.includes(u.id));
        const newUsers = selectedUsers.filter(u => !u.conversation_id);
        const newUserIds = newUsers.map(u => u.id);

        const existingConversationIds = selected_ids.filter(id => !newUserIds.includes(id));

        try {
            let newConversationIds = [];

            // Create new conversations for users without one
            if (newUsers.length > 0) {
                const createRoomPromises = newUsers.map(u =>
                    createDirect({
                        variables: {
                            input: {
                                title: 'Personal',
                                participants: [user?.id, u?.id],
                                company_id: user.company_id,
                                group: 'no',
                            },
                        },
                    })
                );

                const results = await Promise.all(createRoomPromises);
                console.log("🚀 ~ handleForward ~ results:", results)
                newConversationIds = results.map(res => res?.data?.create_room?.data?.conversation_id).filter(Boolean);
                console.log("🚀 ~ handleForward ~ newConversationIds:", newConversationIds)
            }

            const conversationLists = [...existingConversationIds, ...newConversationIds];

            const input = {
                conversation_lists: conversationLists
            };

            if (forward_file) {

                input['file_ids'] = [active_file?.id];
                input['msg_body'] = msg_body;
                input['msg_type'] = 'media_attachment';

                await forwardFile({ variables: { input } });
            } else {
                input['conversation_id'] = active_msg?.conversation_id;
                input['msg_id'] = active_msg?.msg_id;
                input['is_reply_msg'] = active_msg?.is_reply_msg;

                await forward({ variables: { input } });
            }

            toast.success('Message forwarded!');
            handleClosePopup()
        } catch (error) {
            console.error("❌ Error while forwarding message or creating conversations:", error);
            toast.error("Failed to forward message.");
        }
    }

    const minidiv = selected_ids.length > 0 ?
        all_users.filter(u => selected_ids.includes(u.id)).map((v, i) =>
            <div key={v.id} className="miniItem !bg-teal-500">
                <div className="miniItem_name">{v.title}</div>
                {!forward_file && <div className="miniItem_remove !-mt-[0px]" onClick={() => setSelected_ids(selected_ids.filter(id => id !== v.id))}><FaTimes /></div>}
            </div>
        )
        :
        <span className="selectMemberlabel">Select members</span>

    return (

        !forward_file ?
            <div className='participantsPopup animate__animated animate__zoomIn animation_duration dirMPopup'>
                <header className="filterFileHeader  ">
                    <div onClick={handleClosePopup} className="allfilterFileHeader items-center -mt-1">
                        <MdArrowBackIos className="allFileHeaderIcon thread_eHeaderIcon text-2xl -mt-1" />
                        <div className='mt-1'>
                            <span className="allFileHeaderText ">{stepKey === 'directConv' ? 'Start a direct message' : (stepKey === 'forward' || stepKey === 'forward_file') ? 'Select member(s) to forward' : (stepKey === 'createRoom' || stepKey === 'update_room' || stepKey === 'add_team_users') ? 'Add members' : (stepKey === 'private_msg' || stepKey === 'private_participants') ? 'Private message' : ''}</span>
                        </div>
                    </div>
                </header>
                <div className='conversationListContainer'>
                    <div className="searchParticipantsList bgSurfaceDark ">
                        <input
                            type="text"
                            placeholder="Search users"
                            ref={searchInput}
                            onChange={(e) => setSearchText(e.target.value)}
                            value={searchText}
                            className="bgSurfaceDark  dark:text-white dark:border-none text-white"
                        />
                        {searchText && <span className="start_text_btn" onClick={() => setSearchText('')}><div className='closeSearchIconRoom !relative' /></span>}
                        <span className="searchPrivateIconsRoom dark:text-white"></span>
                    </div>
                    <div className="ParticiantScroller bgSurfaceDark ">
                        {loader ? (
                            <div className='main_loader'></div>
                        ) : (
                            all_users?.length > 0 ? (
                                stepKey === 'forward' || stepKey === 'forward_file' ?
                                    <>
                                        <p className='ml-4 text-base text-gray-600 pt-2 dark:text-white'>Rooms</p>
                                        <UserDesign users={filterUser('room')} selected_ids={selected_ids} selectUser={selectUser} online_users={online_users} searchText={searchText} />
                                        <p className='ml-4 text-base text-gray-600 pt-2 dark:text-white'>Users</p>
                                        <UserDesign users={filterUser('user')} selected_ids={selected_ids} selectUser={selectUser} online_users={online_users} searchText={searchText} />
                                    </>
                                    :
                                    <UserDesign users={all_users} selected_ids={selected_ids} selectUser={selectUser} online_users={online_users} searchText={searchText} />
                            )
                                :
                                <p className='NomemberFound'>No member(s) found!</p>
                        )}
                    </div>
                </div>
                <div className="participantsFooter  ">
                    <div className="selectedMembersSec">
                        <div className="membersIcon">
                            <div className="multiUserHeaderIcons" />
                        </div>
                        <div className="selectedMItem">
                            {minidiv}
                        </div>
                    </div>
                    <div className="submitSection">
                        <span className={`participantSubmit min-w-[70px] ${selected_ids.length > 0 ? '' : 'pointer-events-none opacity-[0.6]'} ${actionLoader ? 'btn_loader pointer-events-none' : ''}`} onClick={actionLoader ? null : handleSubmit}>
                            {actionLoader ? '' : stepKey === 'directConv' ? 'Start' : stepKey === 'forward' ? 'Forward' : stepKey === 'forward_file' ? 'Next' : stepKey === 'private_msg' ? 'Next' : 'Submit'}
                        </span>
                    </div>
                </div>
            </div>
            :
            <FileForwardComment handleForward={handleForward} minidiv={minidiv} isOpen={forward_file} onClose={() => setForward_file(false)} />
    );
};

const UserDesign = ({ users, selected_ids, selectUser, online_users, searchText }) => {
    return (
        users?.filter(f => f.title?.toLowerCase()?.includes(searchText?.toLowerCase()) || f.email?.toLowerCase()?.includes(searchText?.toLowerCase())).map((v) =>
            <div className={classNames("directSMSList bgSurfaceDark ", selected_ids.includes(v.id) ? 'selected dark:!bg-[#55595c]' : '')}
                onClick={() => selectUser(v)} key={v.id}
            >
                <div className="conversationImage">
                    {v.img?.includes('img.png') || v.img?.includes('feelix.jpg') ?
                        <h3 className="nameLetters">{v.fnln.toUpperCase()}</h3>
                        :
                        <img src={v.img} alt="user" title="user" />
                    }
                    <div className={classNames("active_status", online_users?.includes(v.id) ? 'online' : 'offline')}></div>
                </div>
                <div className="smsTextContainer">
                    <div className="smsText">
                        <p className="conversationName dark:text-white">{v.title}</p>
                        <p className="conversationLastMsg dark:text-white">{v.email}</p>
                    </div>
                </div>
            </div>
        )
    )
}

export default ListOfUsers;
